import { NotifyHelper } from "../../../helpers/toast";
import { eDanhGiaKetQuaActionTypeDefine } from "../../action-types/danh-gia/IDanhGiaKetQuaActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const danhGiaKetQuaActions = {
    ...generateActions(eDanhGiaKetQuaActionTypeDefine, "DANH_GIA_KET_QUA"),
    ...generateActionForKey(eDanhGiaKetQuaActionTypeDefine, "DANH_GIA_KET_QUA",
        "SAVE_SUCCESS", () => { NotifyHelper.Success("Đã cập nhật") }
    ),
    ...generateActionForKey(eDanhGiaKetQuaActionTypeDefine, "DANH_GIA_KET_QUA",
        "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }
    ),
}